import * as React from 'react';
import { connect } from 'react-redux';
import UtilityService from '../../services/UtilityService';
import * as AuthorizationStore from '../../store/Authorization';

class DownloadAllPartnersInventoryFile extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.downloadPartnerLog = this.downloadPartnerLog.bind(this);
    }

    downloadPartnerLog = async () => {
        window.open("/all-inventory-export.xlsx");
    }

    public render() {
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 mt-2">
                            <button className="btn primary" onClick={this.downloadPartnerLog}>Get Partners Invenotory</button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default connect()(DownloadAllPartnersInventoryFile);
